import "./App.css";
import { Description } from "./components/Description";
import { PageContainer } from "./components/PageContainer";
import { Menu } from "./components/Menu/Menu";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Menu />
      <div className="paper">
        <Description />
        <PageContainer />
        <Footer />
      </div>
    </div>
  );
}

export default App;
